/* ARSHÉ V35 — hamburger hardening: opening the menu must never navigate. */
(function(){
  'use strict';
  function boot(){
    var btn=document.querySelector('.arshe-menu-toggle');
    if(!btn) return;
    btn.setAttribute('type','button');
    btn.setAttribute('role','button');
    btn.removeAttribute('href');
    btn.addEventListener('pointerdown',function(e){
      if(e.button!==0) return;
      e.stopPropagation();
    },true);
    btn.addEventListener('click',function(e){
      e.preventDefault();
    },false);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
})();
